import React, { useLayoutEffect, useRef, useState } from 'react';
import './AnimatedHeight.css';

interface AnimatedHeightProps {
    children: React.ReactNode;
    className?: string;
}

/**
 * Eases its own height to its content's whenever the content grows or
 * shrinks, instead of jumping (a detail pane switching item, a section whose
 * data lands). Keep it outside any `key` that remounts the content, or it
 * restarts with the content and has nothing to ease from.
 */
const AnimatedHeight: React.FC<AnimatedHeightProps> = ({ children, className = '' }) => {
    const innerRef = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState<number | undefined>();

    useLayoutEffect(() => {
        const inner = innerRef.current;
        // jsdom and old browsers: plain auto height.
        if (!inner || typeof ResizeObserver === 'undefined') return;
        const observer = new ResizeObserver(() => setHeight(inner.offsetHeight));
        observer.observe(inner);
        return () => observer.disconnect();
    }, []);

    return (
        <div className={`animated-height ${className}`} style={{ height }} data-testid="animated-height">
            <div ref={innerRef} data-testid="animated-height-content">{children}</div>
        </div>
    );
};

export default AnimatedHeight;
